"use strict";
class NesController {
    constructor() {
        this.nesItems = document.querySelectorAll('.repairArticle__nes__container');
        this.nesContainer = document.getElementById('nes-down');
        this.arrowDown = document.getElementById('nes-down');
        this.arrowUp = document.getElementById('nes-up');
        this.initNes();
    }
    initNes() {
        if (this.nesItems.length <= 0 || !this.arrowDown || !this.arrowUp)
            return;
        this.hideNesHandler();
        MoobiUtilities.listenToElem(this.arrowDown, [this.ArrowDownHandler.bind(this)], 'click', []);
        MoobiUtilities.listenToElem(this.arrowUp, [this.ArrowUpHandler.bind(this)], 'click', []);
    }
    ArrowUpHandler() {
        console.log('up');
        if (this.nesItems.length <= 0 || !this.arrowDown || !this.arrowUp)
            return;
        this.arrowUp.style.display = 'none';
        this.arrowDown.style.display = 'block';
        this.hideNesHandler();
    }
    ArrowDownHandler() {
        console.log('down');
        if (this.nesItems.length <= 0 || !this.arrowDown || !this.arrowUp)
            return;
        this.arrowUp.style.display = 'block';
        this.arrowDown.style.display = 'none';
        this.showNesHandler();
    }
    // if(this.nesItems.length <= 0)return
    hideNesHandler() {
        this.nesItems.forEach((el, ind) => {
            if (ind === 0) {
                this.showNesHalf(el);
            }
            else {
                this.hideNes(el);
            }
        });
    }
    showNesHandler() {
        this.nesItems.forEach((el, ind) => {
            this.showNes(el);
        });
    }
    hideNes(elm) {
        elm.style.maxHeight = '0px';
        elm.classList.remove('shown');
    }
    showNes(elm) {
        elm.style.maxHeight = '3000px';
        elm.classList.add('shown');
    }
    showNesHalf(elm) {
        elm.style.maxHeight = '350px';
        elm.classList.remove('shown');
    }
}
const nesController = new NesController();
